import { FormState } from '../../types/core/form-state.types';
import { PaymentWorkflowType } from '../../types/api/graph.types';
import { createInitialFormState } from '../../hooks/useFormState';
import {
  DUMMY_OVERTIME_WORKFLOW_ID,
  OVERTIME_SECTION_KEYS,
} from './constants';
import {
  OVERTIME_WORKED_GRID_KEY,
  enrichOvertimeWorkedRow,
  toOvertimeFormGridData,
  withTemporaryOvertimeAssignedSections,
} from './utils';
import { isOvertimeApprovalBypassEnabled } from '../../../../../utils/overtimeApprovalBypass';

export const isDummyOvertimeWorkflowId = (
  id: string | undefined
): boolean =>
  isOvertimeApprovalBypassEnabled && id === DUMMY_OVERTIME_WORKFLOW_ID;

// TEMPORARY: Overtime Approval backend permissions are not ready yet.
export const buildDummyOvertimeFormState = (): FormState => {
  const initialState = createInitialFormState(
    PaymentWorkflowType.OvertimeApproval
  );

  return {
    ...initialState,
    isLoading: false,
    currentSection: OVERTIME_SECTION_KEYS.requestDetails,
    data: {
      ...initialState.data,
      id: DUMMY_OVERTIME_WORKFLOW_ID,
      name: 'Dummy Overtime Approval Request',
      currentAuthStage: OVERTIME_SECTION_KEYS.requestDetails,
      createdDate: new Date().toISOString(),
      createdByName: 'Local test user',
      employee_name: 'Test Employee',
      job_title: 'Test Role',
      department: 'Test Department',
      role_type: 'Dummy role',
      employee_number: 'TEST-001',
      standard_working_hours: '37.5',
      line_manager: [
        {
          label: 'Test Line Manager',
          value: 'test.line.manager@example.com',
        },
      ],
      overtime_policy: 'Dummy overtime policy',
      [OVERTIME_WORKED_GRID_KEY]: toOvertimeFormGridData([
        enrichOvertimeWorkedRow({
          date: new Date().toISOString().slice(0, 10),
          day: '',
          from_time: '17:30',
          to_time: '19:30',
          hours: '',
          matter_number: 'TEST-MATTER',
          reason: 'Local overtime workflow testing',
        }),
      ]),
      userAssignedSections: withTemporaryOvertimeAssignedSections([]),
    },
  };
};
